exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".legacy-title[data-v-6bfa4da9] {\n  color: var(--color-accent) !important;\n  font-size: 1.3rem;\n}\n.legacy-title-border[data-v-6bfa4da9]:after {\n  content: \"\";\n  display: inline-block;\n  border-top: 1px solid var(--color-accent);\n  width: 100%;\n}", ""]);

// exports
